<template>
    <div>

        <div class="banner-active">
            <div class="banner-area d-flex align-items-center bg_cover"
                 style="background-image: url('/img/banners/banner-4.png');">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="banner-content text-center">
                                <h1 data-animation="fadeInUp" data-delay="0.5s" class="title">Shop big</h1>
                                <router-link to="/all-categories" data-animation="fadeInUp" data-delay="1.2s"
                                             class="main-btn">SHOP Now
                                </router-link>
                            </div>
                        </div>
                    </div> <!-- row -->
                </div> <!-- container -->
                <div class="banner-shape">
                    <img src="/images/banner-shape.png" alt="shape">
                </div>
            </div>
        </div>

        <Featured/>

        <FeaturedProducts/>

        <section class="discount-area pb-90">
            <div class="container-fluid p-0">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="discount-item bg_cover mt-30"
                             style="background-image: url('/images/discount-bg-1.jpg');">
                            <span>100% natural </span>
                            <h2 class="title">From the farm</h2>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="discount-item bg_cover mt-30"
                             style="background-image: url('/images/discount-bg-2.jpg');">
                            <span>Sale off</span>
                            <h2 class="title">Extra 20% Off </h2>
                            <a class="main-btn main-btn-2" href="product-list.html">Shop Now</a>
                        </div>
                    </div>
                </div> <!-- row -->
            </div> <!-- container fluid -->
        </section>

        <div class="back-to-top">
            <a href="#">
                <i class="ion ion-md-arrow-up"></i>
            </a>
        </div>
        <!--Email verification modal-->
        <div>
            <sweet-modal icon="warning" ref="modal" overlay-theme="dark">
                <strong>Email Verification!</strong><br/>
                Your email has not been verified. Please click the button below to request verification link<br/><br/>
                <button class="btn btn-primary" @click="resend()">Resend</button>
            </sweet-modal>
        </div>
        <div class="vld-parent">
            <loading name="loader" :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="fullPage"></loading>
        </div>
    </div>
</template>
<script>
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';
    import Featured from "../../components/Category/Featured";
    import {SweetModal, SweetModalTab} from 'sweet-modal-vue';
    import FeaturedProducts from "../../components/Products/FeaturedProducts";

    export default {
        name: "Index",
        components: {
            Featured,
            SweetModal,
            SweetModalTab,
            Loading,
            FeaturedProducts
        },
        data() {
            return {
                isLoading: false,
                fullPage: true,
            }
        },
        methods: {
            resend() {
                this.isLoading = true;
                this.$refs.modal.close();
                this.axios.get('/email/resend').then(() => {
                    this.isLoading = false;
                    this.$swal(
                        'Email sent!',
                        'We have sent a verification link to your email: ' + this.$auth.user().email,
                        'success',
                    )
                }).catch(() => {
                    this.isLoading = false;
                    this.$swal(
                        'Something went wrong!',
                        "warning",
                    )
                })
            },
            checkVerified() {
                if (this.$auth.check() && !this.$auth.user().email_verified_at) {
                    var v = this;
                    setTimeout(function () {
                        v.$refs.modal.open();
                    }, 5000);
                }
            }
        },
        created() {
            this.checkVerified();
        }
    }
</script>